<template>
    <div id="app">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <step-browser v-if="step !== 'finish'" :step="step" />
                </div>
                <div class="col-xs-12 col-md-8 col-md-offset-2">
                    <template v-if="step === 'personal'">
                        <step-personal @submit="submitPersonal" />
                    </template>
                    <template v-if="step === 'contact'">
                        <step-contact
                            @submit="submitContact"
                            @back="setStep('personal')"
                        />
                    </template>
                    <template v-if="step === 'upload'">
                        <step-upload
                            @submit="submitUpload"
                            @back="setStep('contact')"
                        />
                    </template>
                    <template v-if="step === 'finish'">
                        <step-finish @submit="redirectHome" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StepPersonal from "./components/step-personal";
import StepContact from "./components/step-contact";
import StepBrowser from "./components/step-browser";
import StepUpload from "./components/step-upload";
import StepFinish from "./components/step-finish";
import { v4 as uuidv4 } from "uuid";
import Utility from "./libs/Utility";

export default {
    name: "app",
    components: {
        StepPersonal,
        StepContact,
        StepBrowser,
        StepUpload,
        StepFinish,
    },
    computed: {
        step: {
            get() {
                if (!this.$route.params["step"]) {
                    return "personal?job=" + this.$store.state.job;
                }
                return this.$route.params["step"];
            },
        },
    },
    watch: {
        step: {
            immediate: true,
            handler() {
                // Check Valid Step.
                // Den letzten Step zu erst prüfen. Solange zurück gehen, bis ein Step valide ist.
                if (
                    this.step === "finish" &&
                    !this.$store.state.stepUploadValid
                ) {
                    this.setStep("upload");
                }
                if (
                    this.step === "upload" &&
                    !this.$store.state.stepContactValid
                ) {
                    this.setStep("contact");
                }
                if (
                    this.step === "contact" &&
                    !this.$store.state.stepPersonalValid
                ) {
                    this.setStep("personal?job=" + this.$store.state.job);
                }
            },
        },
    },
    created() {
        if (!this.$store.state.uuid) {
            this.$store.commit("setUniqueId", uuidv4());
        }

        if (this.$route.query["job"]) {
            this.$store.commit("setJob", this.$route.query["job"]);
            this.$router.push({ query: {} });
        } else if (!this.$store.state.job) {
            alert("Stellenbezeichnung fehlt");
        }
        this.setStep(this.step);
    },
    methods: {
        submitPersonal(e) {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.$store.commit("setPersonalValid", true);
                    this.$store.commit("setPersonalData", e);
                    this.setStep("contact");
                }
            });
        },
        submitContact(e) {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.$store.commit("setContactValid", true);
                    this.$store.commit("setContactData", e);
                    this.setStep("upload");
                }
            });
        },
        submitUpload() {
            this.$store.commit("setUploadValid", true);
            this.setStep("finish");
        },
        setStep(step) {
            if (step === this.$route.params["step"]) {
                return;
            }
            this.$router.push({ path: "/" + step });
        },
        redirectHome() {
            document.location.href = "/";
        },
    },
};
</script>

<style lang="scss">
@import "./scss/_vars";

#app {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    width: 100%;
    background-color: #f1f1f1;
    padding-top: 95px;
    padding-bottom: 30px;

    @media (min-width: map-get($breakpoints, "md")) {
        padding-top: 30px;
    }

    // Global resets
    .contact-form > .row {
        margin-right: -15px;
    }

    .form-container {
        .form-group {
            &.error {
                .errors {
                    font-size: 14px;
                    color: red !important;

                    @media (min-width: map-get($breakpoints, "md")) {
                        font-size: 15px;
                    }
                }
            }
        }

        .form-inner {
            margin-bottom: 50px;
            padding: 16px;
            padding-top: 28px;
            background-color: #fff;
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        }

        .submit {
            margin-bottom: 15px;
        }

        .back {
            color: #00a7af;

            .fa {
                padding: 0;
                position: relative;
                top: 1px;
                line-height: 12px;
                font-size: 16px;
                padding-right: 7px;
            }
        }
    }

    .header {
        margin-bottom: 25px;
        font-size: 16px;
        font-weight: normal;
        line-height: 1.5;
        color: #3a3a3a;
    }

    .description {
        margin-bottom: 60px;

        @media (min-width: map-get($breakpoints, "md")) {
            font-size: 16px;
            line-height: 2;
        }
    }

    .line {
        margin-bottom: 30px;
        background-color: #e0e0e0;
        height: 4px;

        &:after {
            display: block;
            width: 35px;
            height: 4px;
            content: "";
            background-color: #00a7af;
        }
    }

    h3 {
        // Global resets
        margin-top: 0;
        margin-bottom: 0;
        line-height: unset;

        font-size: 16px;
        font-weight: bold;
        color: #3a3a3a;
    }

    h2 {
        // Global resets
        margin-top: 0;
        margin-bottom: 25px;
        line-height: unset;

        font-size: 16px;
        font-weight: bold;
        color: #3a3a3a;
    }
}
</style>
